import Web3 from 'web3/dist/web3.min.js'
import { userLogin, updateInfo } from '@/api/user'
import { setCookie, getCookie, deleteCookie } from '@/utils/cookie'
let state = {
  isClose: false,
  isLogin: false,
  netInfo: {
    web3Instance: null,
    chainId: null,
    balance: null,
    address: null
  },
  userInfo: null
}

const actions = {
  //链接小狐狸钱包
  async connectMetaMaskAction({ commit, dispatch }, payload) {
    // 包装整个函数体，确保即使window.ethereum有问题，应用也不会崩溃
    try {
      // 使用try-catch包装window.ethereum访问
      let ethereumProvider = null
      try {
        ethereumProvider = window.ethereum
      } catch (error) {
        console.warn('Error accessing window.ethereum:', error)
        this._vm.$toast.error(
          'Multiple wallet extensions detected. Please use only one wallet extension.'
        )
        return
      }

      // 检查window.ethereum是否存在，避免多个钱包扩展冲突
      if (!ethereumProvider) {
        this._vm.$toast.error(
          'The Metamask extension is not installed in the current browser'
        )
        return
      }

      // 使用try-catch包装request调用
      let accounts
      try {
        accounts = await ethereumProvider.request({ method: 'eth_requestAccounts' })
      } catch (error) {
        if (error.code === 4001) {
          // EIP-1193 userRejectedRequest error
          // 用户取消登录，无需特殊处理
          return
        } else {
          throw error
        }
      }

      const address = accounts[0]
      const chainId = ethereumProvider.networkVersion

      // 避免直接修改全局window.web3，改为在需要时创建实例
      const web3Instance = new Web3(ethereumProvider)

      // 将web3实例存储在window上，但使用更安全的方式
      if (!window.web3) {
        window.web3 = web3Instance
      }

      // console.log(address);
      let isLogin = getCookie('isLogin')
      if (!isLogin) {
        dispatch('signatureForLogin', { address, chainId, isSwitch: false })
      } else {
        commit('INIT_LOGIN_INFO', { address, chainId })
      }
    } catch (error) {
      console.error('Wallet connection error:', error)
      if (error.message && error.message.includes('Cannot redefine property: ethereum')) {
        // 处理多个钱包扩展导致的ethereum属性重定义错误
        this._vm.$toast.error(
          'Multiple wallet extensions detected. Please use only one wallet extension.'
        )
      } else {
        console.error('Unexpected error:', error)
        this._vm.$toast.error(
          'An error occurred while connecting to your wallet.'
        )
      }
    }
  },
  async initData({ dispatch }) {
    let isLogin = getCookie('isLogin')
    if (isLogin) {
      // Only connect to MetaMask if it's a wallet login with address, not a third-party login
      let userInfo = getCookie('userInfo')
      if (userInfo) {
        userInfo = JSON.parse(userInfo)
        // Only call connectMetaMaskAction if userInfo has wallet address
        if (userInfo.address) {
          dispatch('connectMetaMaskAction')
        }
      }
    }
  },
  async signatureForLogin({ commit, rootState, dispatch }, payload) {
    try {
      let msg = 'This signature is used to verify your identity.'
      let web3 = null

      // 安全获取或创建web3实例
      if (window.web3) {
        web3 = window.web3
      } else if (window.ethereum) {
        web3 = new Web3(window.ethereum)
      } else {
        // 如果没有找到ethereum provider，尝试重新连接钱包
        rootState._vm.$toast.error('Please connect your wallet first.')
        dispatch('connectMetaMaskAction')
        return
      }

      // userState is a temporary state, keep using localStorage
      let userState = JSON.parse(localStorage.getItem('userState') || 'null')
      if (userState && window.web3Wallet) {
        web3 = window.web3Wallet
      }

      // 确保web3实例有效
      if (!web3) {
        throw new Error('Web3 instance not available')
      }

      let code = web3.utils.utf8ToHex(msg)
      //console.log("utf8Hex：", code)
      //console.log(payload)

      let receipte = await web3.eth.personal.sign(code, payload.address)
      // console.log(receipte);

      let result = await userLogin({ signature: receipte, address: payload.address, msg })
      let data = result.data
      let userInfo = data.data

      if (data.code === 1) {
        // "User login succeeded, return information：" + JSON.stringify(userInfo))
        if (!payload.isSwitch) {
          rootState._vm.$toast.success(rootState._vm.$i18nn.t('wallet.toast.t2'))
        } else {
          rootState._vm.$toast.success(rootState._vm.$i18nn.t('wallet.toast.t3'))
        }
        setCookie('userInfo', JSON.stringify(userInfo))
        // "token----",userInfo.token)
        setCookie('token', userInfo.token)
        commit('CONNECT_METAMASK', { address: payload.address, chainId: payload.chainId })
        commit('INIT_LOGIN_INFO', { address: payload.address, chainId: payload.chainId })
        commit('GET_USER_INFO_FROM_LOCAL_STORAGE')
      } else {
        // console.log( this._vm.$toast)
        // console.log(data.msg)
        rootState._vm.$toast.error(data.msg)
      }
    } catch (error) {
      console.error('Signature or login failed:', error)

      // 更具体的错误处理
      if (error.message && error.message.includes('Cannot redefine property: ethereum')) {
        rootState._vm.$toast.error(
          'Multiple wallet extensions detected. Please use only one wallet extension.'
        )
      } else if (error.message && error.message.includes('Web3 instance not available')) {
        rootState._vm.$toast.error('Please connect your wallet first.')
      } else {
        rootState._vm.$toast.error(rootState._vm.$i18nn.t('wallet.toast.t4'))
      }
    }
  }
}

const mutations = {
  //链接小狐狸钱包成功
  CONNECT_METAMASK(state, payload) {
    // debugger
    // console.log('CONNECTED_METAMASK-payload---', payload)
    let isLogin = getCookie('isLogin')
    if (isLogin) {
      return //如果已经登录过了，就不在往下走了
    }
    let netInfoCopy = state.netInfo
    netInfoCopy.address = payload.address
    // netInfoCopy.web3Instance = payload.web3Instance
    netInfoCopy.chainId = payload.chainId
    netInfoCopy.addressStr =
      payload.address.substr(0, 4) + '....' + payload.address.substr(38)
    state.netInfo = netInfoCopy
    state.isClose = false
    state.isLogin = true
    setCookie('isLogin', true)
    setCookie('chainId', netInfoCopy.chainId)
    setCookie('address', payload.address)
    setCookie('userInfo', JSON.stringify(netInfoCopy))
    // console.log('state，，，，', state)
    // 移除页面刷新，使用Vue状态管理来更新UI
  },
  GET_USER_INFO_FROM_LOCAL_STORAGE(state) {
    let userInfo = getCookie('userInfo')

    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      // Handle third-party login userInfo without wallet address
      if (userInfo.address) {
        userInfo.addressStr =
          userInfo.address.substr(0, 4) + '....' + userInfo.address.substr(38)
      }
      state.userInfo = userInfo
      state.isLogin = true
    }
  },
  SHOW_OR_HIDE(state, payload) {
    state.isClose = !state.isClose
  },
  LOGOUTED(state, payload) {
    state.netInfo = {}
    state.userInfo = null
    state.isLogin = false
    // 使用rootState访问Vue实例
    this._vm.$toast.success(this._vm.$i18nn.t('navMenus.other.logoutSuccess'))
    deleteCookie('isLogin')
    deleteCookie('chainId')
    deleteCookie('currentNetwork')
    deleteCookie('userInfo')
    deleteCookie('apiKey')
    deleteCookie('token')
    // 移除页面刷新，使用Vue状态管理来更新UI
  },
  UPDATE_WEB3_INFO(state, payload) {
    let netInfoCopy = state.netInfo
    netInfoCopy.address = payload.address
    netInfoCopy.chainId = payload.chainId
    netInfoCopy.addressStr =
      payload.address.substr(0, 4) + '....' + payload.address.substr(38)
    setCookie('chainId', netInfoCopy.chainId)
    setCookie('address', payload.address)
    state.netInfo = netInfoCopy
    setCookie('userInfo', JSON.stringify(netInfoCopy))
  },
  INIT_LOGIN_INFO(state, payload) {
    // console.log('has login')
    let isLogin = getCookie('isLogin')
    if (isLogin) {
      let userInfo = JSON.parse(getCookie('userInfo'))

      // Handle wallet login case with address and chainId
      if (payload && payload.address) {
        if (userInfo.address != payload.address) {
          userInfo.address = payload.address
          userInfo.addressStr =
            payload.address.substr(0, 4) + '....' + payload.address.substr(38)
          setCookie('address', payload.address)
        }

        let chainId = getCookie('chainId')
        if (!chainId || chainId != payload.chainId) {
          userInfo.chainId = payload.chainId
          setCookie('chainId', payload.chainId)
        }

        state.netInfo = userInfo
      } else {
        // Handle third-party login case without wallet address
        state.netInfo = userInfo
      }

      state.isClose = false
      state.isLogin = true
      setCookie('userInfo', JSON.stringify(userInfo))
      // console.log("INIT_LOGIN_INFO-state : ", JSON.stringify(state))
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
